import { useCallback, useRef } from "react";
import { useUpdateTaskMutation } from "../../store";
import useAuth from "../../Hooks/useAuth";
import { useAlert } from "../../context/AlertContext";

export const QUICK_ASSIGN_CONFLICT = "İş bu arada değişti, lütfen yenileyin.";
const errText = (e, fallback) => e?.data?.message || e?.message || fallback;

// Contract 1.8: işi açmadan atananları değiştirir (liste satırı, üst işin alt iş listesi).
// task: { _id, version, parent? } — alt iş ise parentId verilir ki üst işin detayı tazelensin.
// Kayıtlar sıralı gider; her yanıtın version'ı hatırlanır, tazeleme gelmeden yapılan
// ikinci değişiklik 409 almaz.
export default function useQuickAssign() {
  const { auth } = useAuth();
  const { showWarning, showError } = useAlert();
  const [updateTask] = useUpdateTaskMutation();
  const versions = useRef(new Map());
  const queue = useRef(Promise.resolve());

  return useCallback(
    (task, ids, parentId) => {
      const run = async () => {
        const known = versions.current.get(task._id);
        const version = Math.max(task.version ?? 0, known ?? 0);
        try {
          const res = await updateTask({
            token: auth?.accessToken,
            id: task._id,
            version,
            changes: { assignees: ids },
            task: task._id,
            ...(parentId ? { parent: parentId } : {}),
          }).unwrap();
          const fresh = res?.data?.task;
          if (fresh) versions.current.set(fresh._id, fresh.version);
        } catch (e) {
          const fresh = e?.data?.data?.task;
          if (fresh) versions.current.set(fresh._id, fresh.version);
          if (e?.status === 409) showWarning(QUICK_ASSIGN_CONFLICT);
          else showError(errText(e, "Atama kaydedilemedi."));
        }
      };
      const p = queue.current.then(run, run);
      queue.current = p.catch(() => {});
      return p;
    },
    [auth?.accessToken, updateTask, showWarning, showError]
  );
}
